import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material';
import { MatListModule } from '@angular/material/list';
import { CoreModule } from './core/core.module';
import { ContactModule } from './contact/contact.module';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminModule } from './admin/admin.module';
import { ExpertiseModule } from './expertise/expertise.module';
import { ComptaModule } from './compta/compta.module';
import { JwtModule } from '@auth0/angular-jwt';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MentionModule } from 'angular2-mentions/mention';
import { ComponentsModule } from './components/components.module';
import { Nl2BrPipeModule } from 'nl2br-pipe';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { GrowlModule } from 'primeng/growl';
import { NotificationsService } from './shared/notifications/notifications.service';
import { NotificationsComponent } from './shared/notifications/notifications.component';
import { OAuthModule, OAuthStorage, ValidationHandler, JwksValidationHandler } from 'angular-oauth2-oidc';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
// We need a factory since localStorage is not available at AOT build time
export function storageFactory() : OAuthStorage {
  return localStorage
}

import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE
} from '@angular/material';
import {
    MomentDateModule,
    MomentDateAdapter
} from '@angular/material-moment-adapter';
import { LastPrestationsComponent } from './last-prestations/last-prestations.component';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'DD/MM/YYYY',
        monthYearA11yLabel: 'MM YYYY',
    },
};

export function jwtTokenGetter() {
  return localStorage.getItem('access_token');
};
//

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    NotificationsComponent,
    LastPrestationsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatSidenavModule,
    MatIconModule,
    MatFormFieldModule,
    MatListModule,
    CoreModule,
    ContactModule,
    RouterModule,
    AdminModule,
    ExpertiseModule,
    ComptaModule,
    FormsModule,
    MatInputModule,
    MentionModule,
    ComponentsModule,
    Nl2BrPipeModule,
    ToastModule,
    MessagesModule,
    MessageModule,
    ToolbarModule,
    ButtonModule,
    PanelModule,
     GrowlModule,
     TableModule,
     DropdownModule,
     CalendarModule,
     MessagesModule,
     InputTextModule,
     AutoCompleteModule,
    NgxPermissionsModule.forRoot(),
     OAuthModule.forRoot(),
     JwtModule.forRoot({
      config: {
        tokenGetter: jwtTokenGetter,
        whitelistedDomains: ['localhost'],
        blacklistedRoutes: ['localhost/auth/login']
      }
    })
  ],
  providers: [
      NotificationsService,

      { provide: MAT_DATE_LOCALE, useValue: 'fr' },
      { provide: OAuthStorage, useFactory: storageFactory },

      {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE]
        }, {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS
        }
    ],
      bootstrap: [AppComponent],
  exports: [
    ToolbarModule,
    ButtonModule,
    PanelModule,
  ]
})
export class AppModule { }
